

export const ALLSKILLS = [
    {
        id: 0,
        type: 'b',
        name: "Programming",
        desc: "C/C++, Javascript, Java",
        link: ""
    },
     
    
    {
        id: 1,
        type: 'b',
        name: "Web-Frontend",
        desc: "Bootstrap, React, Redux, Webpack, HTML5, CSS, SCSS",
        link: ""
    },
    
    {
        id: 2,
        type: 'b',
        name: "Mobile",
        desc: "React Native",
        link: ""
    },
    
    {
        id: 3,
        type: 'b',
        name: "Database",
        desc: "Oracle, SQL, Extensive experience",
        link: ""
    },
    
    {
        id: 4,
        type: 'b',
        name: "Networking",
        desc: "TCP/IP, Sockets",
        link: ""
    },
    {
        id:5,
        type: 'b',
        name: "Design",
        desc: "Object Modeling, BPR, Workflo, Process Management",
        link: ""
    },
    {
        id: 6,
        type: 'b',
        name: "Project Management",
        desc: "PMI, Prince",
        link: ""
    },
    {
        id: 7,
        type: 'b',
        name: "Media Enhancements",
        desc: "Photoshop, Photomatix, Pano2vr, On1, Snagit, Camtasia, After Effects, Illustrator, Dreamweaver",
        link: ""
    },
    {
        id: 8,
        type: 'l',
        name: "Legal Research",
        desc: "Strong researcher, Use all available technology, skilled book researcher, very fast, worked at US Supreme Court as researcher",
        link: ""
    },
    {
        id: 9,
        type: 'l',
        name: "Legal Writing",
        desc: "Strong writer, Deep Understanding, Very thourough analysis, very fast",
        link: ""
    },
    {
        id: 10,
        type: 'l',
        name: "Client Interviewing",
        desc: "Witness Statements, Depositions, Won Client Interviewing Competition, Identifying Witnesses", 
        link: ""

    },
    {
        id: 11,
        type: 'l',
        name: "Lexus and Westlaw",
        desc: "Expert at using software to aide in legal research. I was the firm goto person for this.", 
        link: ""

    },
    {
        id: 12,
        type: 'l',
        name: "Subject Area Expertise",
        desc: "Insurance, Energy, Native American, Death Penalty, Criminal Appeals", 
        link: ""

    },
    {
        id: 13,
        type: 's',
        name: "K-12 Teaching",
        desc: "3rd Grade, Middle School and High School Math, Computers, and Social Studies", 
        link: ""

    },
    {
        id: 14,
        type: 's',
        name: "University Teaching",
        desc: "Over 120 courses in 25 subject areas(BA, MA, and MBA), Department Head, Hiring of Professors, Recruitment, Program Creating, Course Writing, Coaching, Career Counseling", 
        link: ""

    },
    {
        id: 16,
        type: 's',
        name: "Business Training",
        desc: "Created many training courses in Database, Networking, Programming, 4th Generation Languages, System Design, Workflow Management, Document Management, many different applications", 
        link: ""

    },
    {
        id: 17,
        type: 's',
        name: "Favorite Courses",
        desc: "Negotiation Skills, Knowledge Management, Cross-Cultural Behavior, Marketing, International Law, Film, C++, Business Communications", 
        link: ""

    },
    {
        id: 18,
        type: 'g',
        name: "IT Manager",
        desc: "", 
        link: ""

    },
    {
        id: 19,
        type: 'g',
        name: "Infrastructure Setup",
        desc: "", 
        link: ""

    },
    {
        id: 20,
        type: 'g',
        name: "Strategic Planning/Analysis",
        desc: "", 
        link: ""

    },
    {
        id: 21,
        type: 'g',
        name: "Industry Networking",
        desc: "", 
        link: ""

    },
    {
        id: 22,
        type: 'g',
        name: "Project Management",
        desc: "", 
        link: ""

    },

    {
        id: 23,
        type: 'g',
        name: "Team Leadership",
        desc: "", 
        link: ""

    },
    {
        id: 24,
        type: 'g',
        name: "Supervision & Training",
        desc: "", 
        link: ""

    },
    {
        id: 25,
        type: 'g',
        name: "Time Management",
        desc: "", 
        link: ""

    },

    {
        id: 26,
        type: 'g',
        name: "Organization & Scheduling",
        desc: "", 
        link: ""

    },
    {
        id: 27,
        type: 'g',
        name: "Data Management",
        desc: "", 
        link: ""

    },
    {
        id: 28,
        type: 'g',
        name: "Documentation & Reporting",
        desc: "", 
        link: ""

    },

    {
        id: 29,
        type: 'g',
        name: "Business Acumen",
        desc: "", 
        link: ""

    }
    
    
    
    
]
    
    
    